import { StyledFigure } from './style'

import * as Icons from './icons'

import { IconProps } from './type'

const Icon = ({
  iconName,
  icSize = 'regular',
  nonFocusable = false,
  preserveFocusOnParent = false,
  ...props
}: IconProps) => {
  const SelectedIcon = Icons[iconName]

  return (
    <StyledFigure
      {...props}
      icSize={icSize}
      nonFocusable={nonFocusable}
      tabIndex={nonFocusable ? -1 : 0}
      onMouseLeave={(e) =>
        preserveFocusOnParent && e.currentTarget.parentElement?.focus()
      }
    >
      <SelectedIcon data-testid={iconName} />
    </StyledFigure>
  )
}

export default Icon
